/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertServiceDto
 */
export interface UpsertServiceDto {
    /**
     * The name of the service.
     * @type {string}
     * @memberof UpsertServiceDto
     */
    name: string;
    /**
     * The description.
     * @type {string}
     * @memberof UpsertServiceDto
     */
    description: string;
    /**
     * The environment settings.
     * @type {{ [key: string]: string; }}
     * @memberof UpsertServiceDto
     */
    environment: { [key: string]: string; };
    /**
     * The currency.
     * @type {string}
     * @memberof UpsertServiceDto
     */
    currency: string;
    /**
     * The price per Core and hour in the selected currency.
     * @type {number}
     * @memberof UpsertServiceDto
     */
    pricePerCoreHour: number;
    /**
     * The price per Memory in GB and hour in the selected currency.
     * @type {number}
     * @memberof UpsertServiceDto
     */
    pricePerMemoryGBHour: number;
    /**
     * The price per Storage in GB and hour in the selected currency.
     * @type {number}
     * @memberof UpsertServiceDto
     */
    pricePerStorageGBMonth: number;
    /**
     * The price per Disk in GB and hour in the selected currency.
     * @type {number}
     * @memberof UpsertServiceDto
     */
    pricePerVolumeGBHour: number;
    /**
     * The additional fixed price.
     * @type {number}
     * @memberof UpsertServiceDto
     */
    fixedPrice: number;
    /**
     * Indicates if the service is public.
     * @type {boolean}
     * @memberof UpsertServiceDto
     */
    isPublic: boolean;
}

/**
 * Check if a given object implements the UpsertServiceDto interface.
 */
export function instanceOfUpsertServiceDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "environment" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "pricePerCoreHour" in value;
    isInstance = isInstance && "pricePerMemoryGBHour" in value;
    isInstance = isInstance && "pricePerStorageGBMonth" in value;
    isInstance = isInstance && "pricePerVolumeGBHour" in value;
    isInstance = isInstance && "fixedPrice" in value;
    isInstance = isInstance && "isPublic" in value;

    return isInstance;
}

export function UpsertServiceDtoFromJSON(json: any): UpsertServiceDto {
    return UpsertServiceDtoFromJSONTyped(json, false);
}

export function UpsertServiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertServiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'environment': json['environment'],
        'currency': json['currency'],
        'pricePerCoreHour': json['pricePerCoreHour'],
        'pricePerMemoryGBHour': json['pricePerMemoryGBHour'],
        'pricePerStorageGBMonth': json['pricePerStorageGBMonth'],
        'pricePerVolumeGBHour': json['pricePerVolumeGBHour'],
        'fixedPrice': json['fixedPrice'],
        'isPublic': json['isPublic'],
    };
}

export function UpsertServiceDtoToJSON(value?: UpsertServiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'environment': value.environment,
        'currency': value.currency,
        'pricePerCoreHour': value.pricePerCoreHour,
        'pricePerMemoryGBHour': value.pricePerMemoryGBHour,
        'pricePerStorageGBMonth': value.pricePerStorageGBMonth,
        'pricePerVolumeGBHour': value.pricePerVolumeGBHour,
        'fixedPrice': value.fixedPrice,
        'isPublic': value.isPublic,
    };
}

